<template>
  <section class="c-profile-header">
    <section class="c-profile-header__avatar">
      <slot name="userAvatar"></slot>
    </section>
    <router-link :to="{name:'ProfileEditSection',params:{section:'details'}}" v-if="currentUser" class="c-profile-header__link">Edit</router-link>
    <section class="c-profile-header__content">
      <slot name="userInfo"></slot>
    </section>

    <hr>
    <article class="c-profile-header__bio">
      <router-link :to="{name:'ProfileEditSection',params:{section:'bio'}}" v-if="currentUser" href="#" class="c-profile-header__link">Edit</router-link>
      <h4>Bio</h4>
      <slot name="userBio"></slot>
    </article>
  </section>
</template>

<script>
export default {
  name: "ProfileHeader",

  props: {
    currentUser: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.c-profile-header {
  background: $colour-nhs-white;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  text-align: center;
  padding: 10px;
  position: relative;
  margin-bottom: 3em;

  a {
    text-decoration: none;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 129px;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 129px;
      background: url("/assets/page-bg.svg") right 30% no-repeat
        $colour-nhs-pale-blue;
      content: "";
      z-index: 0;
    }
  }

  &__avatar {
    width: 111px;
    border-radius: 100%;
    display: inline-block;
    overflow: hidden;
    height: 111px;
    flex: 1;
    position: relative;
    z-index: 1;

    max-width: 111px;
    max-height: 111px;

    @media screen and (min-width: 1024px) {
      margin-top: -60px;
    }

    img {
      width: auto;
      height: 100%;
      margin: 0 auto;
      display: block;
      @supports (object-fit: cover) {
        min-height: 39px;
        width: 100%;
        min-width: 39px;
        height: 100%;
        object-fit: cover;

        max-width: 111px;
        max-height: 111px;
      }
    }
  }

  &__link {
    position: absolute;
    top: 10px;
    right: 10px;

    @media screen and (min-width: 1024px) {
      top: 139px;
    }
  }

  &__content {
    h1 {
      color: $colour-nhs-core-blue;
      font-size: 16px;
      font-weight: bold;
      font-family: $font-frutiger-bold;
    }

    a {
      text-decoration: none;
      margin-bottom: 5px;
      display: block;

      @media screen and (min-width: 1280px) {
        margin-bottom: auto;
        display: inline;
      }
    }
  }

  hr {
    margin: 1em 0 0;
  }

  &__bio {
    text-align: left;
    margin: 1em 0;
    padding: 0 1em;
    position: relative;
  }

  &__bio & {
    &__link {
      top: 0px;
    }
  }
}
</style>